import {
  V2Dialog,
  DialogContent,
  VisuallyHidden,
  DialogTitle,
  DialogDescription,
} from "web-design-system";
import ChooseClient from "@crm/components/search/choose-client";
import { Client } from "creso-core/types";
import { useRouter, useSearch } from "@tanstack/react-router";
import { Route } from "@/routes/__root";
import omit from "lodash/omit";
import CreateMandateForm from "./create-mandate";
import MandateListContainer from "./mandate-list";
import UploadMandateNachForm from "./upload-mandate";

export default function MandateManagementDialog() {
  const router = useRouter();

  const search = useSearch({ from: Route.id });

  let content = null;

  if (search.client_id) {
    if (search.context === "upload") {
      content = <UploadMandateNachForm />;
    } else if (search.context === "create-form") {
      content = <CreateMandateForm />;
    } else {
      content = <MandateListContainer />;
    }
  } else {
    content = (
      <ChooseClient
        onSelect={(client: Client) => {
          router.navigate({
            to: ".",
            search: (prev) => {
              return { ...prev, client_id: client.id };
            },
            replace: true,
          });
        }}
      />
    );
  }

  const onOpenChange = (open: boolean) => {
    if (open) return;
    if (router.history.canGoBack()) {
      router.history.back();
    } else {
      router.navigate({
        to: ".",
        search: (prev) => omit(prev, ["modal", "client_id", "context"]),
        replace: true,
      });
    }
  };

  return (
    <V2Dialog defaultOpen onOpenChange={onOpenChange}>
      <DialogContent className="w-112 p-0 h-150 overflow-hidden">
        <VisuallyHidden>
          <DialogTitle
            title={
              search.context === "create-form"
                ? "Create Mandate"
                : "Mandates list"
            }
          />
          <DialogDescription>
            {search.context === "create-form"
              ? "Create a new mandate"
              : "Manage your mandates"}
          </DialogDescription>
        </VisuallyHidden>
        {content}
      </DialogContent>
    </V2Dialog>
  );
}
